/* eslint-disable react-hooks/exhaustive-deps */

import { ReloadOutlined } from '@ant-design/icons';
import { Col, Row, Tag, Tooltip } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import IconCameraOnvif from '../../assets/icons/camera_onvif.svg';
import IconCameraRtsp from '../../assets/icons/camera_rtsp.svg';
import Info from '../../assets/icons/info.svg';
import Info11 from '../../assets/icons/info_11.svg';
import Info12 from '../../assets/icons/info_12.svg';
import Info3 from '../../assets/icons/info_3.svg';
import Info5 from '../../assets/icons/info_5.svg';
import Info6 from '../../assets/icons/info_6.svg';
import Info7 from '../../assets/icons/info_7.svg';
import LiveIconOn from '../../assets/icons/live-streaming-on.svg';
import OffStream from '../../assets/icons/off_stream.svg';
import PlayIconNoActive from '../../assets/icons/play-button-no-active.svg';
import PlayIcon from '../../assets/icons/play-button.svg';
import Thumbnail from '../../assets/images/thumbnail.jpg';
import * as SERVICE from '../../constants/service.types';
import { ZOOM_STATE } from '../../constants/system.keys';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import {
  changeDialPadData,
  getEndStreamReturn,
  getEndStreamUtraFastReturn,
  socketEmitEvent,
} from '../../redux/actions';

import { calcPercentForVideo } from '../../untils/css';
import PlayerComponent from '../Player';
import './index.scss';

import {
  editOffer,
  generateSdpFragment,
  parseOffer,
  supportsNonAdvertisedCodec,
} from './utils';

const RETRY_PAUSE = 2000;

var pc_config = {
  iceServers: [
    { urls: 'stun:turn01.beex.vn:3478' },
    {
      urls: 'turn:numb.viagenie.ca',
      username: 'webrtc@live.com',
      credential: 'muazkh',
    },
  ],
  bundlePolicy: 'balanced',
  rtcpMuxPolicy: 'negotiate',
  sdpSemantics: 'unified-plan',
};
var pc_constraints = { optional: [{ DtlsSrtpKeyAgreement: true }] };

const ViewStreamComponent = ({
  serial,
  gatewaySerial,
  name,
  typeCamera,
  state,
  resolution,
  iconSize,
  isInternal,
  thumbnail,
  zoomState,
  serviceId,
  isViewAll,
  permission,
  isAllowStreaming,
  allScreen,
  playbackData = {},
}) => {
  const { t } = useTranslation();
  const [countRetryStream, setCountRetryStream] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const dispatch = useDispatch();
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();

  const { streams, namespace, listDeviceContact, streamToken, dataUser } =
    useSelector((state) => state);
  const peerConnection = useRef({});
  const [streaming, setStreaming] = useState();
  const [waitForWatch, setWaitForWatch] = useState(0);
  const [waitForStart, setWaitForStart] = useState(0);
  const [streamSerial, setStreamSerial] = useState(serial);
  const [isConnected, setIsConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const refTryLoad = useRef();
  const [tryLoadTimer, setTryLoadTimer] = useState(10);
  const [isLoadReload, setIsLoadReload] = useState(false);
  const [onPlay, setOnPlay] = useState(false);
  const [sourceObject, setSourceObject] = useState();
  const [checkTransferZoomState, setCheckTransferZoomState] = useState(false);
  const [zoomStatePlayer, setZoomStatePlayer] = useState();
  const [zoomStateDefault, setZoomStateDefault] = useState();
  const [nonAdvertisedCodecs, setNonAdvertisedCodecs] = useState([]);
  const [queuedCandidates, setQueuedCandidates] = useState([]);
  const [sessionUrl, setSessionUrl] = useState('');
  const [offerData, setOfferData] = useState('');
  const [internal, setInternal] = useState(false);

  const refVideoStreamWS = useRef(null);
  const refVideoStreamPC = useRef(null);
  const restartTimeout = useRef();

  const onError = useCallback(
    (err) => {
      console.log('Error: ========>', err);

      if (!restartTimeout.current) {
        if (refVideoStreamPC.current !== null) {
          refVideoStreamPC.current.close();
          refVideoStreamPC.current = null;
        }

        restartTimeout.current = window.setTimeout(() => {
          restartTimeout.current = null;
          loadStream();
        }, RETRY_PAUSE);

        if (sessionUrl) {
          fetch(sessionUrl, {
            method: 'DELETE',
          });
        }

        setSessionUrl('');
        setQueuedCandidates([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sessionUrl]
  );

  useEffect(() => {
    (async () => {
      if (gatewaySerial) {
        try {
          const url = `https://${gatewaySerial}.ezcam.vn:9090/info`;
          const promise = await fetch(url, {
            signal: AbortSignal.timeout(1000),
          });
          const response = await promise.json();
          setInternal(response?.localMedia === 'on');
        } catch (e) {
          setInternal(false);
        } finally {
        }
      }
    })();
  }, [gatewaySerial]);

  useEffect(() => {
    let timeoutClear;
    if (
      onPlay &&
      dataUser?.accountConfiguration &&
      JSON.parse(dataUser?.accountConfiguration)?.liveTimeout > 0
    ) {
      const dataTimeout = JSON.parse(
        dataUser?.accountConfiguration
      )?.liveTimeout;
      timeoutClear = setTimeout(() => {
        setStreaming(null);
        setOnPlay(false);
      }, dataTimeout * 1000);
      return () => {
        clearTimeout(timeoutClear);
      };
    }
  }, [onPlay]);

  useEffect(() => {
    if (zoomState) {
      setZoomStatePlayer(zoomState);
    }
  }, []);

  const compare = (a, b) => {
    if (a.resolution > b.resolution) {
      return -1;
    }
    if (a.resolution < b.resolution) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    const subSourcesTemp = streaming?.subSources
      ? JSON.parse(streaming?.subSources)
      : null;
    if (subSourcesTemp?.length > 0 && zoomStatePlayer && zoomState) {
      const dataArr = subSourcesTemp
        ?.filter((item) => item.resolution >= 0 && item.zoomState >= 0)
        ?.sort(compare);
      let dataArrTemp = [...dataArr];
      // eslint-disable-next-line no-unused-expressions
      zoomState?.dataZoomStates?.map((item) => {
        if (
          !dataArrTemp?.find((item1) => item1?.resolution === item?.resolution)
        ) {
          dataArrTemp.push(item);
        }
      });
      const dataArrTemp1 = dataArrTemp?.sort(compare);
      if (dataArrTemp1?.length > 0) {
        if (
          streaming?.mainSource?.resolution >= 0 &&
          streaming?.mainSource?.zoomState >= 0
        ) {
          setZoomStatePlayer((state) => ({
            resolution:
              state?.resolution || streaming?.mainSource?.resolution || 720,
            zoomState:
              state?.zoomState ??
              streaming?.mainSource?.zoomState ??
              ZOOM_STATE.FOUR,
            dataZoomStates: dataArrTemp1?.map((item) => ({
              resolution: item?.resolution,
              zoomState: item?.zoomState,
            })),
          }));
          setZoomStateDefault({
            resolution:
              state?.resolution || streaming?.mainSource?.resolution || 720,
            zoomState:
              state?.zoomState ??
              streaming?.mainSource?.zoomState ??
              ZOOM_STATE.FOUR,
            dataZoomStates: dataArrTemp1?.map((item) => ({
              resolution: item?.resolution ?? 720,
              zoomState: item?.zoomState ?? ZOOM_STATE.FOUR,
            })),
          });
        } else {
          setZoomStatePlayer((state) => ({
            ...state,
            dataZoomStates: dataArrTemp1?.map((item) => ({
              resolution: item?.resolution,
              zoomState: item?.zoomState,
            })),
          }));
          setZoomStateDefault({
            ...zoomState,
            dataZoomStates: dataArrTemp1?.map((item) => ({
              resolution: item?.resolution ?? 720,
              zoomState: item?.zoomState ?? ZOOM_STATE.FOUR,
            })),
          });
        }
      }
    }
  }, [streaming]);

  const createStream = useCallback(
    (dataBody, playbackQueryTime) => {
      const data = {
        serial: dataBody.serial,
        namespace: dataBody.namespace,
      };

      if (playbackQueryTime) {
        data.queryTime = playbackQueryTime;
      } else {
        data.type = dataBody.type;
        data.serviceId = dataBody.serviceId;
        data.qualityLevel =
          dataBody.qualityLevel ?? zoomState?.zoomState ?? ZOOM_STATE.FOUR;

        data.retry = dataBody.retry;
      }

      const requestId = new Date().getTime();
      let dataObj = {
        appServiceType: playbackQueryTime
          ? SERVICE.START_PLAYBACK_CAMERA
          : SERVICE.START_STREAM_MONITOR,
        requestId,
        body: JSON.stringify(data),
      };
      setWaitForWatch(requestId);
      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch]
  );

  const createRtspStream = useCallback(
    (dataBody) => {
      const requestId = new Date().getTime();
      let dataObj = {
        appServiceType: SERVICE.CREATE_RTSP_STREAM,
        requestId,
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch]
  );

  const watchStream = useCallback(
    (dataBody) => {
      const requestId = new Date().getTime();
      let dataObj = {
        appServiceType: SERVICE.WATCH_STREAM,
        requestId,
        body: JSON.stringify(dataBody),
      };
      setWaitForWatch(0);
      setWaitForStart(requestId);
      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch]
  );

  const handleTryLoad = () => {
    setIsLoadReload(true);
    refTryLoad.current = setInterval(() => {
      setTryLoadTimer((timer) => timer - 1);
    }, 1000);

    //Create stream on reload
    setStreamSerial(serial);
    let dataBody = {
      namespace,
      serial,
      type: internal ? 'internal' : 'external',
      serviceId,
      retry: 0,
    };
    createStream(dataBody, playbackData.queryTime);
  };

  useEffect(() => {
    if (isViewAll) {
      setOnPlay(true);
    }
  }, [isViewAll]);

  useEffect(() => {
    if (tryLoadTimer === 0) {
      setIsLoadReload(false);
      clearInterval(refTryLoad.current);
      setWaitForWatch(0);
      setTryLoadTimer(10);
    }
  }, [tryLoadTimer]);

  useEffect(() => {
    if (streaming && streaming.started && !isConnected) {
      clearInterval(refTryLoad.current);
      setIsConnected(true);
    }
  }, [isConnected, streaming]);

  useEffect(() => {
    if (streams && streamSerial) {
      setStreaming(
        streams.filter((stream) => stream.serial === streamSerial)[0]
      );
    }
  }, [streamSerial, streams]);

  const updateStream = useCallback(
    (requestId, dispatch, streamId, candidate, isDone) => {
      let dataBody = {
        namespace,
        streamId,
        candidate,
        isDone: isDone,
      };
      let dataObj = {
        appServiceType: SERVICE.UPDATE_STREAM,
        requestId,
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    },
    [namespace]
  );

  // Create Stream
  useEffect(() => {
    if (onPlay && state && serial && serviceId) {
      setLoading(true);
      setStreamSerial(serial);
      let dataBody = {
        namespace,
        serial,
        type: internal ? 'internal' : 'external',
        serviceId,
        retry: 0,
      };
      createStream(dataBody, playbackData.queryTime);
    }
  }, [createStream, internal, namespace, onPlay, serial, serviceId, state]);

  const onChangeHover = useCallback(() => {
    if (serial && namespace) {
      let dataBody = {
        namespace,
        serial,
      };
      let dataObj = {
        appServiceType: SERVICE.GET_DEVICE_CONTACT_INFO,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [serial, namespace, dispatch]);

  const restartCallBack = useCallback(
    (dataObject, playbackQueryTime) => {
      if (streaming && serial) {
        let refTimeOut;
        if (refTimeOut) {
          clearInterval(refTimeOut);
        }
        const { streamId, serial } = streaming;
        if (streamId) {
          dispatch(getEndStreamReturn(streamId));
        } else {
          dispatch(getEndStreamUtraFastReturn(serial));
        }

        refTimeOut = setTimeout(() => {
          let dataBody = {
            namespace,
            serial,
            type: internal ? 'internal' : 'external',
            serviceId,
            qualityLevel: dataObject?.qualityLevel,
            retry: 1,
          };
          createStream(dataBody, playbackQueryTime);
        }, 1000);
      }
    },
    [createStream, dispatch, internal, namespace, serial, serviceId, streaming]
  );

  const restartLoadingCallBack = useCallback(
    (dataObject, playbackQueryTime) => {
      if (serial) {
        let refTimeOut;
        if (refTimeOut) {
          clearInterval(refTimeOut);
        }
        dispatch(getEndStreamUtraFastReturn(serial));

        refTimeOut = setTimeout(() => {
          let dataBody = {
            namespace,
            serial,
            type: internal ? 'internal' : 'external',
            serviceId,
            qualityLevel: dataObject?.qualityLevel,
            retry: 1,
          };
          createStream(dataBody, playbackQueryTime);
        }, 1000);
      }
    },
    [createStream, dispatch, internal, namespace, serial, serviceId]
  );

  const restartQualityCallBack = useCallback(
    (dataObject, playbackQueryTime) => {
      if (streaming && serial) {
        let refTimeOut;
        if (refTimeOut) {
          clearInterval(refTimeOut);
        }
        const { streamId, serial } = streaming;
        if (streamId) {
          dispatch(getEndStreamReturn(streamId));
        } else {
          dispatch(getEndStreamUtraFastReturn(serial));
        }

        refTimeOut = setTimeout(() => {
          let dataBody = {
            namespace,
            serial,
            type: internal ? 'internal' : 'external',
            serviceId,
            qualityLevel: dataObject?.qualityLevel,
            retry: 0,
          };
          createStream(dataBody, playbackQueryTime);
        }, 1000);
      }
    },
    [createStream, dispatch, internal, namespace, serial, serviceId, streaming]
  );

  useEffect(() => {
    if (playbackData.queryTime && onPlay) {
      restartCallBack(null, playbackData.queryTime);
    }
  }, [playbackData.queryTime]);

  useEffect(() => {
    if (
      streaming &&
      streaming.serial &&
      !streaming.streamId &&
      streaming.streamMonitorId &&
      !streaming.sdpOffer &&
      !streaming.started &&
      !streaming.path &&
      !streaming.wsHost &&
      !streaming.wssPort
    ) {
      let dataBody = {
        namespace,
        serial: streaming.serial,
        streamMonitorId: streaming.streamMonitorId,
        serviceId,
      };
      createRtspStream(dataBody);
    }
  }, [namespace, streaming, createRtspStream, serviceId]);

  const sendLocalCandidates = useCallback(
    (candidates, url) => {
      if (url && offerData && streamToken) {
        fetch(url, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/trickle-ice-sdpfrag',
            'If-Match': '*',
            Authorization: `BeeX a:${streamToken}`,
          },
          body: generateSdpFragment(offerData, candidates),
        })
          .then((res) => {
            switch (res.status) {
              case 204:
                break;
              case 404:
                throw new Error('stream not found');
              default:
                throw new Error(`bad status code ${res.status}`);
            }
          })
          .catch((err) => {
            console.log('Error ===========> ', err);
            onError(err.toString());
          });
      }
    },
    [sessionUrl, offerData, streamToken, onError]
  );

  const onLocalCandidate = useCallback(
    (evt) => {
      if (restartTimeout.current) {
        return;
      }

      if (evt.candidate !== null) {
        if (sessionUrl === '') {
          setQueuedCandidates((prev) => [...prev, evt.candidate]);
        } else {
          sendLocalCandidates([evt.candidate]);
        }
      }
    },
    [sendLocalCandidates, sessionUrl]
  );

  const onConnectionState = useCallback(() => {
    if (restartTimeout.current !== null) {
      return;
    }

    if (refVideoStreamPC.current.iceConnectionState === 'disconnected') {
      onError('peer connection closed');
    }
  }, [onError]);

  const onTrack = (evt) => {
    setSourceObject(evt.streams[0]);
  };

  const onRemoteAnswer = useCallback(
    (sdp, sessionUrl) => {
      if (restartTimeout.current) {
        return;
      }

      refVideoStreamPC.current
        .setRemoteDescription(
          new RTCSessionDescription({
            type: 'answer',
            sdp,
          })
        )
        .then(() => {
          if (queuedCandidates.length !== 0) {
            sendLocalCandidates(queuedCandidates, sessionUrl);
            setQueuedCandidates([]);
          }
        })
        .catch((err) => {
          console.log('Error ========>', err);
          onError(err.toString());
        });
    },
    [onError, queuedCandidates, sendLocalCandidates]
  );

  const sendOffer = (offer) => {
      if (
        streaming &&
        streaming?.path &&
        streaming?.wsHost &&
        streaming?.wssPort
      ) {
        const baseEndpoint = `https://${streaming.wsHost}:${streaming.wssPort}`;

        fetch(`${baseEndpoint}${streaming.path}/whep`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/sdp',
            Authorization: 'BeeX a:' + streamToken,
          },
          body: offer.sdp,
        })
          .then((res) => {
            switch (res.status) {
              case 201:
                break;
              case 404:
                throw new Error('stream not found');
              case 400:
                return res.json().then((e) => {
                  throw new Error(e.error);
                });
              default:
                throw new Error(`bad status code ${res.status}`);
            }
            const sessionUrl = `${baseEndpoint}${res.headers.get('location')}`;
            setSessionUrl(`${baseEndpoint}${res.headers.get('location')}`);
            return res.text().then((sdp) => onRemoteAnswer(sdp, sessionUrl));
          })
          .catch((err) => {
            onError(err.toString());
          });
      }
    };

  const createOffer = () => {
    refVideoStreamPC.current
      .createOffer()
      .then((offer) => {
        offer.sdp = editOffer(offer.sdp, nonAdvertisedCodecs);
        setOfferData(parseOffer(offer.sdp));
        refVideoStreamPC.current
          .setLocalDescription(offer)
          .then(() => {
            sendOffer(offer);
          })
          .catch((err) => {
            onError(err.toString());
          });
      })
      .catch((err) => {
        onError(err.toString());
      });
  };

  const loadStream = useCallback(() => {
    // create peer connection webrtc
    refVideoStreamPC.current = new RTCPeerConnection(pc_config);

    const direction = 'sendrecv';
    refVideoStreamPC.current.addTransceiver('video', { direction });
    refVideoStreamPC.current.addTransceiver('audio', { direction });

    refVideoStreamPC.current.onicecandidate = (evt) => onLocalCandidate(evt);
    refVideoStreamPC.current.oniceconnectionstatechange = () =>
      onConnectionState();
    refVideoStreamPC.current.ontrack = (evt) => onTrack(evt);

    createOffer();
  }, [createOffer, onConnectionState, onLocalCandidate]);

  const getNonAdvertisedCodecs = useCallback(() => {
    Promise.all(
      [
        ['pcma/8000/2'],
        [
          'multiopus/48000/6',
          'channel_mapping=0,4,1,2,3,5;num_streams=4;coupled_streams=2',
        ],
        ['L16/48000/2'],
      ].map((c) =>
        supportsNonAdvertisedCodec(c[0], c[1]).then((r) => (r ? c[0] : false))
      )
    )
      .then((c) => c.filter((e) => e !== false))
      .then((codecs) => {
        setNonAdvertisedCodecs(codecs);
        loadStream();
      });
  }, [loadStream]);

  useEffect(() => {
    if (
      streaming &&
      streaming.serial &&
      !streaming.streamId &&
      streaming.streamMonitorId &&
      !streaming.sdpOffer &&
      !streaming.started &&
      streaming.path &&
      streaming.wsHost &&
      streaming.wssPort &&
      !streaming.hlsPort &&
      countRetryStream
    ) {
      const start = () => {
        const restartPause = 2000;
        let terminated = false;
        let restartTimeout = null;

        const scheduleRestart = () => {
          if (terminated) {
            return;
          }

          if (refVideoStreamWS.current !== null) {
            refVideoStreamWS.current.close();
            refVideoStreamWS.current = null;
          }

          if (refVideoStreamPC.current !== null) {
            refVideoStreamPC.current.close();
            refVideoStreamPC.current = null;
          }

          restartTimeout = window.setTimeout(() => {
            restartTimeout = null;
            start();
          }, restartPause);
        };

        const onRemoteCandidate = (msg) => {
          if (refVideoStreamPC.current === null) {
            return;
          }
          refVideoStreamPC.current.addIceCandidate(JSON.parse(msg.data));
        };

        const onRemoteDescription = (msg) => {
          if (
            refVideoStreamPC.current === null ||
            refVideoStreamWS.current === null
          ) {
            return;
          }
          if (refVideoStreamPC.current) {
            const d = JSON.parse(msg.data);
            if (d && d instanceof Array) {
              refVideoStreamPC.current = new RTCPeerConnection({
                iceServers: d,
              });
            } else {
              refVideoStreamPC.current.setRemoteDescription(
                new RTCSessionDescription(JSON.parse(msg.data))
              );
            }
          }

          refVideoStreamWS.current.onmessage = (msg) => onRemoteCandidate(msg);
        };

        const onIceCandidate = (evt) => {
          if (refVideoStreamWS.current === null) {
            return;
          }

          if (evt.candidate !== null) {
            if (evt.candidate.candidate !== '') {
              refVideoStreamWS.current.send(JSON.stringify(evt.candidate));
            }
          }
        };

        const onIceServers = (msg) => {
          if (refVideoStreamWS.current === null) {
            return;
          }

          const iceServers = JSON.parse(msg.data);

          refVideoStreamPC.current = new RTCPeerConnection({
            iceServers,
          });

          refVideoStreamWS.current.onmessage = (msg) =>
            onRemoteDescription(msg);
          refVideoStreamPC.current.onicecandidate = (evt) =>
            onIceCandidate(evt);

          refVideoStreamPC.current.oniceconnectionstatechange = () => {
            if (refVideoStreamPC.current === null) {
              return;
            }

            // should restart
            if (
              refVideoStreamPC.current.iceConnectionState === 'disconnected'
            ) {
              console.log(
                'Retry connect when iceConnectionState is disconnected'
              );

              start();
            }
          };

          refVideoStreamPC.current.ontrack = (evt) => {
            setSourceObject(evt.streams[0]);
          };

          const direction = 'sendrecv';
          refVideoStreamPC.current.addTransceiver('video', { direction });
          refVideoStreamPC.current.addTransceiver('audio', { direction });

          refVideoStreamPC.current.createOffer().then((desc) => {
            if (
              refVideoStreamPC.current === null ||
              refVideoStreamWS.current === null
            ) {
              return;
            }

            refVideoStreamPC.current.setLocalDescription(desc);
            setWaitForStart(0);
            refVideoStreamWS.current.send(JSON.stringify(desc));
          });
        };

        refVideoStreamWS.current = new WebSocket(
          `wss://${streaming.wsHost}:${streaming.wssPort}${streaming.path}/ws`
        );

        refVideoStreamWS.current.onerror = () => {
          if (refVideoStreamWS.current === null) {
            return;
          }
          if (
            refVideoStreamWS.current &&
            refVideoStreamWS.current.readyState === 1
          ) {
            refVideoStreamWS.current.close();
          }

          refVideoStreamWS.current = null;
          console.log('Retry connect on error');
          start();
        };

        refVideoStreamWS.current.onclose = () => {
          refVideoStreamWS.current = null;
        };

        refVideoStreamWS.current.onmessage = (msg) => onIceServers(msg);

        refVideoStreamWS.current.onopen = () => {
          const data = { token: streamToken };
          if (refVideoStreamWS?.current) {
            if (refVideoStreamWS.current.readyState === 1) {
              refVideoStreamWS.current.send(JSON.stringify(data));
            } else {
              let timeoutRef = setTimeout(() => {
                refVideoStreamWS.current.send(JSON.stringify(data));
                if (timeoutRef) {
                  clearTimeout(timeoutRef);
                }
              }, 2000);
            }
          }
        };
      };
      const requestId = new Date().getTime();
      setWaitForWatch(0);
      setWaitForStart(requestId);
      if (streaming?.version === 'v2') {
        // Handle with new method
        getNonAdvertisedCodecs();
      } else {
        start();
      }
    }
  }, [streaming, streamToken, countRetryStream]);

  useEffect(() => {
    if (
      streaming &&
      streaming.serial &&
      !streaming.streamId &&
      streaming.streamMonitorId &&
      !streaming.sdpOffer &&
      !streaming.started &&
      streaming.path &&
      streaming.wsHost &&
      streaming.wssPort &&
      streaming.hlsPort &&
      countRetryStream
    ) {
      setSourceObject({
        mode: 'hls',
        link:
          streaming?.version === 'v2'
            ? `https://${streaming?.wsHost}:${streaming?.hlsPort}${streaming?.path}/index.m3u8?token=${streamToken}`
            : `https://${streaming?.wsHost}:${streaming?.hlsPort}/${streamToken}${streaming?.path}/index.m3u8`,
      });
    }
  }, [streaming, streamToken, countRetryStream]);

  // Watch Stream
  useEffect(() => {
    if (
      streaming &&
      streaming.serial &&
      streaming.streamId &&
      !streaming.sdpOffer &&
      !streaming.started
    ) {
      let dataBody = {
        namespace,
        serial: streaming.serial,
        streamId: streaming.streamId,
      };
      watchStream(dataBody);
    }
  }, [namespace, streaming, watchStream]);

  useEffect(() => {
    if (streaming && streaming.sdpOffer && !streaming.started) {
      const offerOptions = {
        offerToReceiveAudio: true,
        offerToReceiveVideo: true,
      };
      if (peerConnection.current && peerConnection.current.connectionState) {
        peerConnection.current.close();
      }
      peerConnection.current = new RTCPeerConnection(pc_config, pc_constraints);
      let sdpData = {
        type: 'offer',
        sdp: streaming.sdpOffer,
      };
      let remoteSessionDescription = new RTCSessionDescription(sdpData);
      if (peerConnection.current) {
        peerConnection.current
          .setRemoteDescription(remoteSessionDescription)
          .then(() => {
            peerConnection.current
              .createAnswer(offerOptions)
              .then((localDescription) => {
                peerConnection.current
                  .setLocalDescription(localDescription)
                  .then(() => {
                    // start stream here
                    let dataBody = {
                      streamId: streaming.streamId,
                      sdpAnswer: localDescription.sdp,
                      namespace,
                    };
                    let dataObj = {
                      appServiceType: SERVICE.START_STREAM,
                      requestId: new Date().getTime(),
                      body: JSON.stringify(dataBody),
                    };
                    setWaitForStart(0);
                    return dispatch(socketEmitEvent(dataObj));
                  })
                  .catch((error) => {});
              })
              .catch((error) => {});
          })
          .catch((error) => {});

        peerConnection.current.onicecandidate = (event) => {
          const requestId = new Date().getTime();

          if (event.candidate) {
            peerConnection.current.addIceCandidate(event.candidate);
            // call update stream
            updateStream(
              requestId,
              dispatch,
              streaming.streamId,
              event.candidate.candidate,
              0
            );
          } else {
            //call update stream
            updateStream(requestId, dispatch, streaming.streamId, '', 1);
          }
        };

        peerConnection.current.ontrack = (event) => {
          if (event) {
            setSourceObject(event.streams[0]);
          }
        };
      }
    }
  }, [dispatch, namespace, streaming, updateStream]);

  useEffect(() => {
    if (streaming && zoomState?.zoomState && streaming.started) {
      setLoading(false);
      let dataBody = {
        streamId: streaming.streamId,
        zoomState: zoomStatePlayer?.zoomState ?? ZOOM_STATE.FOUR,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.ZOOM_STATE_STREAM,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, streaming, namespace]);

  // Stop stream on exit
  useEffect(() => {
    return () => {
      if (
        streaming &&
        streaming.started &&
        streaming.status &&
        streaming.status.length > 0
      ) {
        const { streamId } = streaming;
        let dataBody = {
          streamId,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.STOP_STREAM,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        setStreaming(null);
        dispatch(socketEmitEvent(dataObj));
        dispatch(getEndStreamReturn(streamId));
      }
    };
  }, [dispatch, namespace, streaming]);

  // Stop stream ultra fast on exit
  useEffect(() => {
    return () => {
      if (
        streaming &&
        streaming.wsHost &&
        streaming.wssPort &&
        streaming.path &&
        !streaming.hlsPort
      ) {
        if (
          refVideoStreamWS.current &&
          refVideoStreamWS.current.readyState === 1
        ) {
          refVideoStreamWS.current.close();
        }

        refVideoStreamWS.current = null;

        if (refVideoStreamPC.current) {
          refVideoStreamPC.current.close();
        }
        refVideoStreamPC.current = null;
        setStreaming(null);
        dispatch(getEndStreamUtraFastReturn(streaming.serial));
      }
    };
  }, [dispatch, streaming]);

  // Stop stream hls fast on exit
  useEffect(() => {
    return () => {
      if (
        streaming &&
        streaming.wsHost &&
        streaming.wssPort &&
        streaming.path &&
        streaming.hlsPort
      ) {
        setStreaming(null);
        setSourceObject(null);
        dispatch(getEndStreamUtraFastReturn(streaming.serial));
      }
    };
  }, [dispatch, streaming]);

  const onRotateCamera = useCallback(
    (navigator) => {
      if (streaming?.serial) {
        let dataBody = {
          navigator,
          namespace,
          serial: streaming?.serial,
        };
        let dataObj = {
          appServiceType: SERVICE.ROTATE_VIEW_CAMERA,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, streaming]
  );
  const onZoomCamera = useCallback(
    (zoom) => {
      if (streaming?.serial) {
        let dataBody = {
          zoom,
          namespace,
          serial: streaming?.serial,
        };
        let dataObj = {
          appServiceType: SERVICE.ZOOM_VIEW_CAMERA,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, streaming]
  );

  return (
    <div className="view-stream-component" style={{ height: '100%' }}>
      {state === 1 || isConnected ? (
        !!!sourceObject && (
          <div className="icon-live-stream">
            <img
              width={iconSize ? iconSize : 26}
              height={iconSize ? iconSize : 26}
              className="icon"
              alt="live-stream-icon"
              src={LiveIconOn}
            />
          </div>
        )
      ) : (
        <>
          <div className="name-camera">{name}</div>
          <div className="icon-live-stream">
            <img
              width={iconSize ? iconSize : 26}
              height={iconSize ? iconSize : 26}
              className="icon"
              alt="live-stream-icon"
              src={OffStream}
            />
          </div>
        </>
      )}
      {!!!sourceObject && (
        <div className="icon-type-stream">
          <img
            width={iconSize ? iconSize : 26}
            height={iconSize ? iconSize : 26}
            className="icon"
            alt="live-stream-icon"
            src={typeCamera === 'onvif' ? IconCameraOnvif : IconCameraRtsp}
          />
        </div>
      )}
      {!!!sourceObject && (
        <Tooltip
          placement="left"
          mouseEnterDelay={0.5}
          title={
            <>
              <Row>
                <Col span={24}>
                  <Row
                    style={{
                      borderBottom: '1px solid #303030',
                      paddingBottom: '10px',
                    }}
                  >
                    <Col
                      span={18}
                      style={{
                        fontWeight: 'bold',
                        fontSize: '13px',
                        color: 'hsla(0,0%,100%,.85)',
                      }}
                    >
                      {listDeviceContact?.name || ''}
                    </Col>
                    <Col span={6}>
                      {listDeviceContact?.state === 1 ? (
                        <Tag color="rgb(14, 147, 71)">Online</Tag>
                      ) : (
                        <Tag color="rgb(79, 77, 77)">Offline</Tag>
                      )}
                    </Col>
                  </Row>
                </Col>
                {/* <Col span={24}>
                  <img
                    className="info-icon-stream"
                    alt="live-stream-icon"
                    src={Info1}
                  />
                  <span style={{ color: '#0E9347' }}>Camera: {listDeviceContact?.name || ''}</span>
                </Col> */}
                {listDeviceContact?.note && (
                  <Col
                    span={24}
                    style={{
                      color: 'hsla(0, 0%, 100%, 0.65)',
                      marginTop: '10px',
                      fontSize: '13px',
                    }}
                  >
                    <img
                      className="info-icon-stream"
                      alt="live-stream-icon"
                      style={{ marginTop: '-2px' }}
                      src={Info3}
                    />
                    {listDeviceContact?.note || ''}
                  </Col>
                )}
                {state === 0 && (
                  <Col span={24}>
                    <Row>
                      {listDeviceContact?.errorTime && (
                        <Col
                          span={24}
                          style={{
                            color: 'hsla(0, 0%, 100%, 0.65)',
                            marginTop: '5px',
                            fontSize: '13px',
                          }}
                        >
                          <img
                            className="info-icon-stream"
                            alt="live-stream-icon"
                            style={{ marginTop: '-2px' }}
                            src={Info11}
                          />
                          {t('Time')}:{' '}
                          <span style={{ color: 'rgb(245, 47, 57)' }}>
                            {listDeviceContact?.errorTime || ''}
                          </span>
                        </Col>
                      )}
                      {listDeviceContact?.errorMessage && (
                        <Col
                          span={24}
                          style={{
                            color: 'hsla(0, 0%, 100%, 0.65)',
                            marginTop: '5px',
                            fontSize: '13px',
                          }}
                        >
                          <img
                            className="info-icon-stream"
                            alt="live-stream-icon"
                            style={{ marginTop: '-2px' }}
                            src={Info12}
                          />
                          {t('Reason')}:{' '}
                          <span style={{ color: 'rgb(245, 47, 57)' }}>
                            {listDeviceContact?.errorMessage || ''}
                          </span>
                        </Col>
                      )}
                    </Row>
                  </Col>
                )}
                <Col span={24} style={{ marginTop: '10px', fontSize: '13px' }}>
                  <img
                    className="info-icon-stream"
                    alt="live-stream-icon"
                    style={{ marginTop: '-2px' }}
                    src={Info5}
                  />
                  <span style={{ color: '#0E9347' }}>
                    {t('PERSON IN CHARGE')}
                  </span>
                </Col>
                {listDeviceContact?.assigners?.length > 0 &&
                  listDeviceContact.assigners.map((item, index) => (
                    <Col span={24} key={index}>
                      <Row>
                        {item.fullName && (
                          <Col
                            span={24}
                            style={{
                              color: 'hsla(0, 0%, 100%, 0.65)',
                              marginTop: '5px',
                              fontSize: '13px',
                            }}
                          >
                            <img
                              className="info-icon-stream"
                              alt="live-stream-icon"
                              style={{ marginTop: '-2px' }}
                              src={Info6}
                            />
                            {t('Họ tên')}: {item.fullName || ''}
                          </Col>
                        )}
                        {item.phoneNumber && (
                          <Col
                            span={24}
                            style={{
                              color: 'hsla(0, 0%, 100%, 0.65)',
                              marginTop: '5px',
                              fontSize: '13px',
                            }}
                          >
                            <img
                              className="info-icon-stream"
                              alt="live-stream-icon"
                              style={{ marginTop: '-2px' }}
                              src={Info7}
                            />
                            {t('Phone number')}:{' '}
                            <span
                              style={{
                                color: '#0E9347',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                dispatch(
                                  changeDialPadData({
                                    show: true,
                                    phone: item.phoneNumber,
                                  })
                                );
                              }}
                            >
                              {item.phoneNumber || ''}
                            </span>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  ))}
              </Row>
            </>
          }
        >
          <div className="icon-info-stream" onMouseOver={() => onChangeHover()}>
            <img
              width={iconSize ? iconSize : 26}
              height={iconSize ? iconSize : 26}
              className="icon"
              alt="live-stream-icon"
              src={Info}
            />
          </div>
        </Tooltip>
      )}
      {state === 0 &&
        !isConnected &&
        permission &&
        permission.split('_') &&
        permission.split('_').find((item) => item === 'live') && (
          <>
            <div
              onClick={() =>
                !isLoadReload && isAllowStreaming !== 0 && handleTryLoad()
              }
              className="preload-spinner reconnect"
            >
              <ReloadOutlined
                className={isAllowStreaming === 0 ? 'no-active' : ''}
                style={{ fontSize: 48 }}
                spin={isLoadReload}
              />
            </div>
            {isAllowStreaming === 0 && (
              <div className="text-no-active">
                <Tag color="#f50">{t('Not active')}</Tag>
              </div>
            )}
          </>
        )}
      {onPlay ? (
        <PlayerComponent
          key={playbackData.queryTime || '0'}
          name={name}
          onvif={typeCamera === 'onvif'}
          onRotate={onRotateCamera}
          onZoom={onZoomCamera}
          resolution={resolution}
          zoomStateProps={zoomStateDefault ?? zoomState}
          isFullscreenProps={isFullscreen}
          restartCallBack={(dataObject) =>
            restartCallBack(dataObject, playbackData.queryTime)
          }
          restartLoadingCallBack={(dataObject) =>
            restartLoadingCallBack(dataObject, playbackData.queryTime)
          }
          fullScreenCallBack={(isFull) => setIsFullscreen(isFull)}
          status={streaming && streaming.status}
          type="streaming"
          loading={loading}
          sourceObject={sourceObject}
          poster={thumbnail && thumbnail.match(/http/g) ? thumbnail : Thumbnail}
          setOnPlay={setOnPlay}
          serial={serial}
          checkTransferZoomState={checkTransferZoomState}
          zoomStatePlayer={zoomStatePlayer}
          setZoomStatePlayer={setZoomStatePlayer}
          restartQualityCallBack={(dataObject) =>
            restartQualityCallBack(dataObject, playbackData.queryTime)
          }
          isHlsStreaming={!!streaming?.hlsPort}
          allScreen={allScreen}
          protocol={streaming?.protocol}
        />
      ) : (
        <div
          className="video-wrapper thumbnail"
          style={{
            paddingBottom: allScreen
              ? '56.25%'
              : `${calcPercentForVideo(
                  windowHeight - 108,
                  windowWidth - 324
                )}%`,
          }}
        >
          {state === 1 &&
            permission &&
            permission.split('_') &&
            permission.split('_').find((item) => item === 'live') && (
              <>
                <img
                  alt="play-icon"
                  onClick={() => {
                    if (isAllowStreaming !== 0) {
                      setOnPlay(true);
                    }
                  }}
                  src={isAllowStreaming === 0 ? PlayIconNoActive : PlayIcon}
                />
                {isAllowStreaming === 0 && (
                  <div className="text-no-active">
                    <Tag color="#f50">{t('Not active')}</Tag>
                  </div>
                )}
              </>
            )}
          <video
            poster={
              thumbnail && thumbnail.match(/http/g) ? thumbnail : Thumbnail
            }
          />
        </div>
      )}
    </div>
  );
};

export default ViewStreamComponent;
